import * as allActions from "./actions";
import * as allConstants from "./constants";

export { default as saga } from "./saga";
export { FileReducer as reducer } from "./reducer";

export const actions = allActions;
export const constants = allConstants;
